__webpack_require__.p = "/risk-explorer-for-software-supply-chains/";